module.exports = __webpack_public_path__ + "static/assets/32d903cafc72328bd30afce14bfa4c79.svg";